<template>
    <base-layout>
        <template v-slot:header>
            <router-view></router-view>
            <h1 class="text-3xl font-bold leading-tight text-gray-900">
                Edukacija
            </h1>
        </template>
        <template v-slot:default>
            <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5 mb-5">
                <div>
                    <div>
                        <h3 class="text-lg leading-6 font-medium text-gray-900">
                            {{ video.title }}
                        </h3>
                        <p class="mt-1 max-w-4xl text-sm text-gray-500">
                            Pogledaj video klip i pripremi se za rešavanje kviza
                            na tu temu.
                        </p>
                    </div>
                </div>
            </div>
            <div v-if="video.youtube_video_id" class="space-y-8 sm:space-y-5 mb-5 h-auto">
                <youtube
                    class="sm:hidden"
                    @playing="playing"
                    @ended="ended"
                    :playerWidth="320"
                    :playerHeight="165"
                    :video-id="video.youtube_video_id"
                    :player-vars="{
                        controls: 1,
                        fs: 0,
                        modestbranding: 1,
                        disablekb: 1,
                    }"
                ></youtube>
                <youtube
                    class="hidden sm:flex"
                    @playing="playing"
                    @ended="ended"
                    :video-id="video.youtube_video_id"
                    :player-vars="{
                        controls: 1,
                        fs: 0,
                        modestbranding: 1,
                        disablekb: 1,
                    }"
                ></youtube>
                <p
                    v-if="video.end_watching_time"
                    class="mt-1 max-w-4xl text-sm text-gray-500"
                >
                    Video pregledan:
                    <time>{{ video.end_watching_time }} h</time>
                </p>
            </div>
            <div class="pt-5">
                <div class="flex justify-start">
                    <router-link
                        type="button"
                        to="/education"
                        class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 cursor-pointer"
                    >
                        Povratak
                    </router-link>
                </div>
            </div>
        </template>
    </base-layout>
</template>

<script>
import EducationVideo from './EducationVideo';
export default EducationVideo;
</script>
